import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { CarouselScrollContainer } from './ShopByType.style';

export const SocialProofContainer = styled.div`
  max-width: 1712px;
  padding: 16px 0;
  margin: auto;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    padding: 16px;
  }

  @media (min-width: 1714px) {
    border-left: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
    border-right: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
  }
`;

export const SocialProofSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 1208px;
  margin: auto;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    flex-direction: row;
  }

  @media (min-width: 1608px) {
    max-width: 100%;
    padding: 0px 160px;
  }
`;

export const SocialProofSectionContainer = styled.div`
  background-color: ${props => props.theme.COLORSV3.FOREST_100};
  padding: 40px 0px;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    border-radius: 16px;
    padding: 60px 24px;
  }
`;

export const SectionHeading = styled.div`
  margin-bottom: 38px;
  padding: 0 24px;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    max-width: 270px;
    padding: 0;
  }
`;

export const SectionTitle = styled.h2`
  margin-bottom: 15px;
  color: ${props => props.theme.COLORSV3.MINT_100};

  font-size: ${props => props.theme.FONTS.FONT_SIZE_LARGER};
  font-family: ${props => props.theme.FONTS.FONT_FAMILY_CIRCULAR};
  line-height: 38px;
  letter-spacing: -1.3px;

  span {
    font-family: ${props => props.theme.FONTS.FONT_FAMILY_NEW_SPIRIT};
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    margin-bottom: 24px;

    font-size: ${props => props.theme.FONTS.FONT_SIZE_SEMI_HUGE};
  }
`;

export const SectionSubTitle = styled.h6`
  color: ${props => props.theme.COLORSV3.MINT_100};
  font-size: ${props => props.theme.FONTS.FONT_SIZE_REGULAR};
  font-weight: ${props => props.theme.FONTS.FONT_WEIGHT_REGULAR};
  letter-spacing: -0.02em;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    font-size: ${props => props.theme.FONTS.FONT_SIZE_LARGE};
  }
`;

export const StyledScrollCarousel = styled(CarouselScrollContainer)`
  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    margin-left: 38px;
  }
`;

export const SocialProofCard = styled.div`
  padding: 14px 14px 30px;
  margin: 0 12px;

  border: 2px solid ${props => props.theme.COLORSV3.BLACK_100};
  border-radius: 16px;
  background-color: ${props => props.theme.COLORSV3.WHITE_100};

  :first-of-type {
    margin-left: 24px;
  }

  :last-of-type {
    margin-right: 24px;
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    :first-of-type {
      margin-left: 0px;
    }

    :last-of-type {
      margin-right: 0px;
    }
  }
`;

export const SocialProofCardImg = styled.img`
  display: block;
  width: 252px;
`;

export const SocialProofCardLabel = styled.h6`
  margin-top: 26px;

  font-size: ${props => props.theme.FONTS.FONT_SIZE_SMALL};
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
`;

export const StyledLinkV2 = styled(LinkV2)`
  text-transform: none;
`;
